import qs from 'qs'

// 课程模式,1:语音直播;2:语音录播;3:视频直播;4:视频录播
//公用的组件和方法
import util from '@/base/js/util'
import ShareDialog from './share-dialog.vue'

//局部的组件和方法
export default {
  data() {
    return {
      shareVisible: false,
      share_info: {}, //分享的信息
    }
  },
  methods: {
    toLink(...args) {
      util.toLink(...args)
    },
    //页码置为0
    chearSearchState(){
      this.search.page=1;
    },
    downline(api, params, operation) {
      this.$confirm('下架后已购用户仍可查看，未购买用户将无法购买，确认下架吗？', '提示', {
        confirmButtonText: '下架',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api({
          params: params
        }).then(res => {
          if (res.resultCode == 1) {
            //做一些刷新操作
            operation();
            this.$message.success(res.errorMsg)
          } else {
            this.$message.error(res.errorMsg)
          }
        })
      }).catch(() => {})
    },
    online(api, params, operation) {
      // console.log(api,params,operation);
      this.$confirm('确认上架？', '提示', {
        confirmButtonText: '上架',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api({
          params: params
        }).then(res => {
          console.log(res);
          if (res.resultCode == 1) {
            //做一些刷新操作
            operation();
            this.$message.success(res.errorMsg)
          } else {
            this.$message.error(res.errorMsg)
          }
        })
      }).catch(() => {})
    },
    delItem(api, params, operation) {
      // console.log(api,params,operation);
      this.$confirm('删除后，已购用户将无法使用该课程，且不可恢复。是否确认删除？', '提示', {
        confirmButtonText: '永久删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api({
          params: params
        }).then(res => {
          console.log(res);
          if (res.resultCode == 1) {
            //做一些刷新操作
            operation();
            this.$message.success(res.errorMsg)
          } else {
            this.$message.error(res.errorMsg)
          }
        })
      }).catch(() => {})
    },
    //下载图片地址和图片名
    downloadIamge(imgsrc, name) {
      util.downloadIamge(imgsrc, name);
    },
    openShare(id, type) {
      this.share_info = {
        id: String(id),
        type: type
      };
      this.shareVisible = true
    }
  },
  components: {
    ShareDialog
  }
}
